export const META_TYPE = 'board';
export const META_VER = 'v1';

export const CMD_BOARD_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
